
import { PackageData } from "@/pages/CreatePackage";

export const mockPackageData: PackageData = {
    clientName: 'اسم العميل المثال',
    clientEmail: 'client@example.com',
    clientPhone: '+966500000000',
    clientType: 'individual',
    packageName: 'باقة سياحية تجريبية',
    destination: 'باريس, فرنسا',
    duration: '7 أيام',
    totalPrice: 2500,
    notes: 'هذه ملاحظات تجريبية للمعاينات.',
    clientAddress: '',
    
    // Required fields
    numberOfRooms: 2,
    numberOfNights: 7,
    mealPlans: ['breakfast'],
    adultsCount: 2,
    childrenCount: 1,
    infantsCount: 0,
    
    // New transport and flight details
    receptionCarsCount: 1,
    tourCarsCount: 1,
    internationalBaggageCount: 1,
    internationalBaggageWeight: 23,
    internationalCabinWeight: 7,
    domesticBaggageCount: 1,
    domesticBaggageWeight: 20,
    domesticCabinWeight: 7,
    
    citiesPlan: [],
    
    // Package inclusions
    includesHotels: true,
    includesInternationalFlights: true,
    includesDomesticFlights: false,
    includesTransport: true,
    includesTours: true,
    includesServices: false,
    
    hotels: [
        { name: 'فندق الشانزليزيه', location: 'باريس', checkIn: '2025-08-01', checkOut: '2025-08-08', nights: 7, roomType: 'غرفة مزدوجة', pricePerNight: 150 },
    ],
    flights: [
        { 
            airline: 'الخطوط السعودية', 
            from: 'الرياض', 
            to: 'باريس', 
            date: '2025-08-01', 
            type: 'outbound', 
            time: '10:00', 
            class: 'Economy', 
            price: 600,
            adults: 2,
            children: 1,
            infants: 0,
            costPrice: 500,
            sellingPrice: 600
        },
    ],
    tours: [
        { name: 'جولة برج إيفل', description: 'زيارة المعلم الأكثر شهرة في باريس.', duration: '3 ساعات', date: '2025-08-02', price: 50, included: ['تذكرة دخول', 'مرشد سياحي'] },
        { name: 'متحف اللوفر', description: 'استكشاف الفن والتاريخ الغني.', duration: '4 ساعات', date: '2025-08-03', price: 70, included: ['تذكرة دخول'] },
    ],
    inclusions: [],
    exclusions: [],
    services: [],
    basePrice: 2500,
    profitType: 'percentage',
    profitValue: 20,
    profitAmount: 500,
    discount: 0,
    taxes: 0,
    paymentTerms: '',
    transport: [],
};
